import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import { IUser, IUserCredential } from "app/auth/user.model";
import { IonicPage, Nav, NavParams } from "ionic-angular";
import { NavigationService } from "navigation/navigation.service";
import { commonVar } from "providers/common-var/common";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@IonicPage({
  name: "sign-in-page",
  segment: "sign-in-page",
})
@Component({
  selector: "sign-in",
  templateUrl: "./sign-in.html",
})
export class SignInPage {
  emailRegex = commonVar.EMAIL_REGEX;
  loading: boolean;
  user: IUserCredential;
  errorMessage: String;
  showPassword: boolean;
  @ViewChild(Nav) nav: Nav;
  showSuccessMessage: boolean;

  passwordInputType: string = "password";

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private authSvc: AuthService,
    public navSvc: NavigationService,
    public navParams: NavParams,
    private cdr: ChangeDetectorRef,
    private configurationService: ConfigurationService
  ) {
    this.loading = false;
    this.user = {
      password: "",
    } as IUser;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  ngAfterViewInit() {
    this.showSuccessMessage = this.navParams.get("showSuccessMessage");
    this.errorMessage = this.navParams.get("errorMessage");
    this.cdr.detectChanges();
  }

  ionViewCanEnter() {
    this.authSvc.authenticationSubject
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          const user = this.authSvc.getUser();
          if (user.selectedOrgType !== "COMPANY") {
            this.navSvc.goToInternalPage("dashboard-page", {});
          } else {
            this.navSvc.goToInternalPage("CompanyDetailsPage", {});
          }
        }
      });
    return true;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  public signIn(): void {
    this.loading = true;
    // Validation of input fields
    if (!this.validateInputFields()) {
      this.loading = false; // Set loading to false if validation fails
      return;
    }
    if (!this.validatePassword(this.user.password)) {
      this.loading = false;
      this.errorMessage = "Incorrect email or password. Please try again";
      return;
    }
    // Sign in
    this.authSvc
      .signIn(this.user)
      .then(() => {})
      .catch((error) => {
        this.handleError(error);
      })
      .then(() => {
        this.loading = false; // Set loading to false regardless of whether sign in succeeded or failed
      });
  }

  private validateInputFields(): boolean {
    if (!this.user.email || !this.user.password) {
      this.errorMessage = "Please fill in all fields";
      return false;
    }

    if (!this.isEmailValid(this.user.email)) {
      this.errorMessage = "Incorrect email or password. Please try again.";
      return false;
    }

    this.errorMessage = "";
    return true;
  }

  private handleError(error: any): void {
    if (error && error.code === "NotAuthorizedException") {
      if (error.message === "Password attempts exceeded") {
        this.errorMessage =
          "You have exceeded the maximum number of login attempts. Please wait a few minutes and try again";
      } else {
        this.errorMessage = "Incorrect email or password. Please try again.";
      }
    } else if (error.code === "UserNotFoundException") {
      this.errorMessage = "Incorrect email or password. Please try again.";
    } else {
      this.errorMessage =
        error.message || "An error occurred while logging in.";
    }
  }

  isEmailValid(email: string): boolean {
    return this.emailRegex.test(email);
  }
  validatePassword(password: string): boolean {
    // Rule 1: Minimum length of 8 characters
    if (password.length < 8) {
      return false;
    }

    // Rule 3: Must use characters from at least 3 of the 4 specified categories
    const regexCategories = [
      /[A-Z]/, // Uppercase
      /[a-z]/, // Lowercase
      /[0-9]/, // Digits
      /[~!@#$%^*&?.+_'/{|}-]/, // Special characters
    ];
    let categoryCount = 0;
    for (const regexCategory of regexCategories) {
      if (regexCategory.test(password)) {
        categoryCount++;
      }
    }
    if (categoryCount < 4) {
      return false;
    }

    // Rule 4: Must not use control characters and other non-printing characters
    const regexControlCharacters = /[\x00-\x1F\x7F]/; // Control and non-printing characters
    if (regexControlCharacters.test(password)) {
      return false;
    }
    // Rule 5: Must not contain any spaces
    const regexSpaces = /\s/;
    if (regexSpaces.test(password)) {
      return false;
    }

    return true; // The password meets all the rules
  }

  public forgotPassword(): void {
    this.navSvc.goToInternalPage("forgot-password", {});
  }

  public firstTimeLogin(): void {
    this.navSvc.goToInternalPage("first-time-login", {});
  }

  public termsConditions(): void {
    // window.open(this.configurationService.getConfig().termsConditions, '_blank');
    this.navSvc.goToInternalPage("terms-conditions", {});
  }
}



// WEBPACK FOOTER //
// ./src/components/cognito/sign-in-cognito/sign-in.ts